import { useEffect } from "react";
import { APP_STORE_URL, GOOGLE_PLAY_URL } from "./helperConstants";

const AppDownload = () => {
  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    let target = APP_STORE_URL;

    if (/android/i.test(ua)) {
      target = GOOGLE_PLAY_URL;
    } else if (/iPad|iPhone|iPod/.test(ua)) {
      target = APP_STORE_URL;
    }

    window.location.href = target;
  }, []);

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h2>Redirecting to Morph App...</h2>
      <p>
        If you are not redirected, <a href={APP_STORE_URL}>click here</a>.
      </p>
    </div>
  );
};

export default AppDownload;
